import axios from "axios";

const getStaticAssets = async <Data>(
  locale: string,
  name: string
): Promise<Data> => {
  const response = await axios.get<Data>(`/static/${locale}/${name}`, {
    baseURL: import.meta.env.VITE_CLIENT_URL,
    timeout: 9000,
  });

  return response.data;
};

export const staticAssetsApi = {
  getStaticAssets,
};
